import { useCallback } from 'react';
import { useSetAtom } from 'jotai';
import { useCallingAddon } from './use-calling-addon';
import { FreeTrialStep } from '../components/call-free-trial/typings';
import { waVoiceUpgradeModalOpen } from '../states';
import { freeTrialStepAtom } from '../components/call-free-trial/states';

/**
 * Returns a function to open the WA voice upgrade flow. Chooses the correct modal up front:
 * - If trial has ended and not renewed → opens TrialEnded modal
 * - Otherwise → opens the upgrade modal (trial CTA or purchase)
 * Use this instead of setWaVoiceUpgradeModalOpen(true) to avoid flicker.
 */
export function useOpenWaVoiceUpgradeFlow() {
  const { hasCallingTrialEnded } = useCallingAddon();
  const setWaVoiceUpgradeModalOpen = useSetAtom(waVoiceUpgradeModalOpen);
  const setFreeTrialStep = useSetAtom(freeTrialStepAtom);

  const openWaVoiceUpgradeFlow = useCallback(() => {
    if (hasCallingTrialEnded) {
      setFreeTrialStep(FreeTrialStep.TrialEnded);
    } else {
      setWaVoiceUpgradeModalOpen(true);
    }
  }, [hasCallingTrialEnded, setFreeTrialStep, setWaVoiceUpgradeModalOpen]);

  return { openWaVoiceUpgradeFlow };
}
